const mod = require('easy-peasy')

module.exports = mod
